import React from 'react';

import {
    useCurationConfigState,
    useCurationConfigValue
} from '../../../../hooks/widgetConfiguration.js';

import useThemesSupported from '../../hooks/useThemesSupported.js';

import {
    useRIQTooltip
} from '../../../../components/RIQPopover.jsx';

import {
    listeningDefinitions
} from '../enums/listeningDefinitions.jsx';

const {ListeningThemes} = RivalIQ.metrics.new.enums;


function ThemeSelect({themeId, isChecked, isDisabled, onThemeToggled}) {

    function onClick(e) {
        e.stopPropagation();

        if (isDisabled) {
            return;
        }
        onThemeToggled(themeId);
    }

    return (
        <button
            key={themeId}
            className='tlw-m-0 tlw-mb-2.5 tlw-flex tlw-items-center tlw-border-0 tlw-bg-transparent tlw-p-0 '
            onClick={onClick}
        >
            <div
                className='tlw-h-10 tlw-w-10'
            >
                <input
                    type='checkbox'
                    checked={isChecked && !isDisabled}
                    disabled={isDisabled}
                    readOnly
                />
            </div>

            <span
                className={`tlw-ml-5 tlw-truncate ${isDisabled ? 'tlw-pointer-events-none tlw-opacity-65' : ''}`}
            >
                {ListeningThemes[themeId].name}
            </span>
        </button>
    );
}


export default function ThemeInclusions() {

    const language = useCurationConfigValue('language');
    const themesSupported = useThemesSupported(language);
    const [theme, setTheme] = useCurationConfigState('theme');
    const selectedThemeIds = _.keyBy(theme);

    const {setTriggerRef, tooltipNode} = useRIQTooltip({
        text: listeningDefinitions['theme-inclusions'].themesNotAvailable,
        placement: 'top',
        disabled: themesSupported
    });

    function onThemeToggled(themeId) {
        let updatedThemeIds = [];
        if (selectedThemeIds[themeId]) {
            updatedThemeIds = _.without(theme, themeId);
        } else {
            updatedThemeIds = _.concat(theme, [themeId]);
        }

        updatedThemeIds = _.compact(updatedThemeIds).sort();
        setTheme(updatedThemeIds);
    }

    return (
        <div
            className='tlw-mx-8 tlw-flex tlw-flex-col tlw-text-gray-900'
            ref={setTriggerRef}
        >

            {_.map(ListeningThemes, theme => {
                return (
                    <ThemeSelect
                        key={theme.id}
                        themeId={theme.id}
                        isChecked={Boolean(selectedThemeIds[theme.id])}
                        onThemeToggled={onThemeToggled}
                        isDisabled={!themesSupported}
                    />
                );
            })}

            {tooltipNode}
        </div>
    );
}
